<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="userbusinessunits">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>Unidades de Negocio - {{ company.nombre }} &nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field
                            :disabled="bEdit"
                            hide-details
                            single-line
                            v-model="searchText"
                        ></v-text-field>
                        <v-btn :disabled="bEdit" small icon @click="onSearch">
                            <v-icon>search</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="bEdit"
                                text
                                class="text-none"
                                @click="onNewBusinessUnit"
                            >Nueva</v-btn>
                            <v-btn
                                :disabled="(bEdit || businessUnitID === 0 )"
                                text
                                class="text-none"
                                @click="onEditBusinessUnit"
                            >Editar</v-btn>
                            <v-btn
                                :disabled="(bEdit || businessUnitID === 0 )"
                                text
                                class="text-none"
                                @click="onDeleteBusinessUnit"
                            >Borrar</v-btn>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="bEdit" @click="onClose" v-on="on">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-5">
                                <v-list-item :disabled="bEdit" @click="onNewBusinessUnit">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">note_add</v-icon>&nbsp; Nueva
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onEditBusinessUnit">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">edit</v-icon>&nbsp; Editar
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onDeleteBusinessUnit">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">delete</v-icon>&nbsp; Borrar
                                    </v-list-item-title>
                                </v-list-item>

                                <v-divider></v-divider>
                                <v-list-item :disabled="bEdit" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de unidades de negocio y unidad de negocio seleccionada: -->
                    <v-container pa-2 grid-list-md>
                        <!-- Renglón para lista de unidades de negocio y card de unidad de negocio seleccionada: -->
                        <v-layout row>
                            <!-- Lista de Unidades de Negocio: *************************** -->
                            <v-flex xs4 sm4>
                                <v-card>
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Unid. de Negocio Registradas</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>list</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        style="height: 578px; max-height:100%"
                                        class="overflow-y-auto"
                                        :disabled="bEdit"
                                        color="grey lighten-5"
                                    >
                                        <v-list-item-group
                                            v-model="selectedBusinessUnitIndex"
                                            color="orange accent-4"
                                            mandatory
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(businessUnit, i) in businessUnits"
                                                :key="i"
                                                @click="selectBusinessUnit(businessUnit.unidadnegocioid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                    md2
                                                                    xs6
                                                                >{{ businessUnit.nombre }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Unidades de Negocio ********************************* -->

                            <!-- Info de Unidad de Negocios seleccionada: *********************** -->
                            <v-flex xs8 sm8>
                                <v-card color="grey lighten-5">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ selectedBusinessUnitName }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>business_center</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        prepend-icon="business_center"
                                                        name="nombre"
                                                        label="Nombre de la Unidad de Negocios"
                                                        type="text"
                                                        v-model="name"
                                                        :readonly="!bEdit"
                                                        ref="name_field"
                                                        color="teal darken-3"
                                                        @blur="onNameBlur"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap justify-space-between>
                                                <v-flex
                                                    xs12
                                                    sm2
                                                    md2
                                                    class="subtitle-2 pt-sm-5 text-xs-center text sm-center text-md-end"
                                                >Ventas:</v-flex>
                                                <v-flex xs12 sm9 md3 class="text-center">
                                                    <v-text-field
                                                        :readonly="!bEdit"
                                                        prepend-icon="attach_money"
                                                        name="sales"
                                                        type="text"
                                                        color="teal darken-3"
                                                        v-model="sales"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md7>
                                                    <v-radio-group
                                                        v-model="currency"
                                                        row
                                                        :mandatory="true"
                                                    >
                                                        <v-radio
                                                            :readonly="!bEdit"
                                                            label="Millones de Pesos"
                                                            value="1"
                                                            color="orange accent-4"
                                                        ></v-radio>
                                                        <v-radio
                                                            :readonly="!bEdit"
                                                            label="Millones de Dólares"
                                                            value="2"
                                                            color="orange accent-4"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 md4 class="text-center">
                                                    <v-checkbox
                                                        :readonly="!bEdit"
                                                        label="Asignar al usuario"
                                                        v-model="businessUnitForUser.bAssigned"
                                                        color="orange accent-4"
                                                        @change="onAssign"
                                                    ></v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 md8 class="text-center">
                                                    <v-text-field
                                                        name="nombreParaUsuario"
                                                        label="Nombre para el Usuario"
                                                        type="text"
                                                        v-model="businessUnitForUser.name"
                                                        :readonly="!bEdit || !businessUnitForUser.bAssigned"
                                                        ref="user_function_name"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout
                                                v-if="bEdit"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                        :disabled="!bEdit"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        :disabled="!bEdit"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de unidad de negocio seleccionada *********************** -->
                        </v-layout>

                        <!-- Modal para confirmar borrado de Unidad de Negocios: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingBusinessUnit" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Borrar Unidad de Negocios</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">warning</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                >¿Desea borrar la unidad de negocios {{ selectedBusinessUnitName }}?</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >Esta acción no se puede deshacer.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteBusinessUnitConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteBusinessUnit"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de Unidad de Negocios *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Búsqueda de Unidades de Negocio</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>search</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">warning</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No hay unidades de negocio registradas con ese nombre.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        <!-- Modal para informar que los datos no son válidos: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Información no Válida</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>error_outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">error</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que los datos no son válidos *********************************** -->

                        <!-- Termina renglón para lista de unidades de negocio y unidad de negocio seleccionada -->
                    </v-container>
                    <!-- Termina container para lista de unidades de negocio y unidad de negocio seleccionada -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'UserBusinessUnits',
    data() {
        return {
            drawer: false,
            bEdit: false,
            bNew: false,
            bInvalidData: false,
            errorMessage: '',
            businessUnitID: 0,
            name: '',
            sales: 0,
            currency: '0', //'1' = MXP, '2' = USD, variable asociada al radio (al parecer tiene que ser string).
            selectedBusinessUnitName: '',
            bDeletingBusinessUnit: false,
            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.
            bAssignedToUser: false,
            userFunctionName: ''
        };
    },
    created() {
        this.selectFirstBusinessUnit();
    },
    methods: {
        onClose() {
            this.$router.push('/');
        },
        onNewBusinessUnit() {
            this.bEdit = true;
            this.bNew = true;
            this.selectedBusinessUnitName = 'Nueva Unidad de Negocio';
            this.selectedBusinessUnitIndex = -1;
            this.businessUnitID = 0;
            this.name = '';
            this.sales = 0;
            this.currency = '1'; //Por default MXP
            this.businessUnitForUser.bAssigned = true;
            this.businessUnitForUser.name = '';

            this.$refs.name_field.focus();
        },
        onDeleteBusinessUnit() {
            this.bDeletingBusinessUnit = true;
        },
        cancelDeleteBusinessUnit() {
            this.bDeletingBusinessUnit = false;
        },
        deleteBusinessUnitConfirmed() {
            this.bDeletingBusinessUnit = false;

            //Se crea un objeto con el id y la empresaid de la unidad de negocio, ya que además del id
            //de la unidad de negocio se necesita la empresaid, para que en store.js se vuelvan a pedir
            //todas las unidades de negocio de la empresa:

            const unitToDelete = {
                unidadnegocioid: this.businessUnitID,
                empresaid: this.company.empresaid
            };

            this.$store.dispatch('deleteBusinessUnit', unitToDelete);
            this.selectFirstBusinessUnit();
        },
        onEditBusinessUnit() {
            this.bEdit = true;
        },
        onAssign() {
            if (this.businessUnitForUser.bAssigned) {
                this.businessUnitForUser.name = this.name;
            } else {
                this.businessUnitForUser.name = '';
            }
        },
        onNameBlur() {
            //Se pone el nombre para el usuario igual al nombre de la función si no se había escrito nada todavía
            //en el nombre para el usuario:
            if (
                this.businessUnitForUser.bAssigned &&
                this.businessUnitForUser.name === ''
            ) {
                this.businessUnitForUser.name = this.name;
            }
        },
        onCancel() {
            if (this.bNew) {
                this.name = '';
                //Selecciona a la primera unidad de negocios de la lista:
                this.selectFirstBusinessUnit();
                this.bNew = false;
            } else {
                //Vuelve a obtener los datos originales de la Unidad de Negocio seleccionada:
                this.selectBusinessUnit(this.businessUnitID);
            }
            this.bEdit = false;
        },
        onSave() {
            var bDataOK = false;

            //Se quitan las comas a las ventas, si las hubiera:
            var tempSales = this.sales.replace(/[',']/g, '');
            //console.log('tempSales = ', tempSales);

            //Se validan los datos:
            if (this.name === '') {
                this.bInvalidData = true;
                this.errorMessage = 'Teclee el nombre de la unidad de negocio.';
            } else if (isNaN(tempSales)) {
                this.bInvalidData = true;
                this.errorMessage = 'Escriba un número válido para las ventas.';
            } else if (
                tempSales === 0 ||
                tempSales === '0' ||
                tempSales === '0.00'
            ) {
                this.bInvalidData = true;
                this.errorMessage = 'Ingrese las ventas.';
            } else if (this.sales < 0) {
                this.bInvalidData = true;
                this.errorMessage = 'Las ventas no pueden ser negativas.';
            } else if (this.currency !== '1' && this.currency !== '2') {
                this.bInvalidData = true;
                this.errorMessage = 'Seleccione una moneda.';
            } else if (
                this.businessUnitForUser.bAssigned &&
                this.businessUnitForUser.name === ''
            ) {
                this.bInvalidData = true;
                this.errorMessage = 'Teclee el nombre para el usuario.';
            } else {
                bDataOK = true;
            }

            if (!this.bNew && bDataOK) {
                //Edición de una Unidad de Negocio
                var i;
                for (i = 0; i < this.businessUnits.length; i++) {
                    if (
                        this.businessUnits[i].unidadnegocioid ===
                        this.businessUnitID
                    ) {
                        var nombreParaUsuario = '';
                        if (this.businessUnitForUser.bAssigned) {
                            nombreParaUsuario = this.businessUnitForUser.name;
                        }

                        // this.businessUnits[i].nombre = this.name;
                        // this.businessUnits[i].ventas = this.sales;
                        // this.businessUnits[i].moneda = Number(this.currency);

                        const businessUnitToEdit = {
                            unidadnegocioid: this.businessUnits[i]
                                .unidadnegocioid,
                            nombre: this.name,
                            empresaid: this.businessUnits[i].empresaid,
                            moneda: Number(this.currency),
                            ventas: tempSales,
                            nombreUsuario: nombreParaUsuario,
                            usuariosunidadesdenegocioid: this
                                .businessUnitForUser.id
                        };

                        //Actualiza el registro en la BD:

                        this.$store.dispatch(
                            'updateUserBusinessUnit',
                            businessUnitToEdit
                        );

                        break;
                    }
                }
            } //end edición de Unidad de Negocio.
            else if (this.bNew && bDataOK) {
                //Registro de nueva Unidad de Negocio.
                this.bNew = false;

                var nombreParaUsuario = '';
                if (this.businessUnitForUser.bAssigned) {
                    nombreParaUsuario = this.businessUnitForUser.name;
                }

                const newBusinessUnit = {
                    empresaid: this.company.empresaid,
                    nombre: this.name,
                    ventas: tempSales,
                    moneda: Number(this.currency),
                    nombreUsuario: nombreParaUsuario
                };

                //console.log('newBusinessUnit = ', newBusinessUnit);

                this.$store.dispatch(
                    'saveNewUserBusinessUnit',
                    newBusinessUnit
                );
            } //end registro de nueva unidad de negocio.

            if (bDataOK) {
                this.selectedBusinessUnitName = this.name;
                this.bEdit = false;
            }
        },
        selectFirstBusinessUnit() {
            console.log('this.businessUnits = ', this.businessUnits);
            console.log(
                'selectedBusinessUnitIndex = ',
                this.selectedBusinessUnitIndex
            );

            if (this.businessUnits.length > 0) {
                this.selectedBusinessUnitIndex = 0;
                var businessUnitID = this.businessUnits[
                    this.selectedBusinessUnitIndex
                ].unidadnegocioid;
                this.selectBusinessUnit(businessUnitID);
            } else {
                this.selectedBusinessUnitIndex = -1;
                this.businessUnitID = 0;
            }
        },
        selectBusinessUnit(businessUnitID) {
            var i;
            for (i = 0; i < this.businessUnits.length; i++) {
                if (this.businessUnits[i].unidadnegocioid === businessUnitID) {
                    this.businessUnitID = businessUnitID;
                    this.name = this.businessUnits[i].nombre;
                    this.selectedBusinessUnitName = this.name;
                    this.sales = this.businessUnits[i].ventas;
                    this.currency = this.businessUnits[i].moneda.toString(10);

                    this.$store.dispatch(
                        'fetchBusinessUnitForUser',
                        businessUnitID
                    );

                    break;
                }
            }
        },
        onSearch() {
            if (this.searchText != '') {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.businessUnits.length; i++) {
                    var strLowerCaseText = this.businessUnits[
                        i
                    ].nombre.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0) {
                        this.selectedBusinessUnitIndex = i;
                        this.selectBusinessUnit(
                            this.businessUnits[i].unidadnegocioid
                        );
                        bFound = true;
                        break;
                    }
                }
                if (!bFound) {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        }
    },
    computed: {
        ...mapGetters(['businessUnits', 'waitCursor', 'company']),

        selectedBusinessUnitIndex: {
            get() {
                return this.$store.getters.selectedBusinessUnitIndex;
            },
            set(selectedBusinessUnitIndex) {
                this.$store.dispatch(
                    'updateSelectedBusinessUnitIndex',
                    selectedBusinessUnitIndex
                );
            }
        },

        businessUnitForUser: {
            get() {
                return this.$store.getters.businessUnitForUser;
            },
            set(businessUnitForUser) {
                this.$store.dispatch(
                    'updateBusinessUnitForUser',
                    businessUnitForUser
                );
            }
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '30%';
            }
            return width;
        }
    }
};
</script>

<style scoped>
.sub-window {
    background-color: #e0e0e0; /*grey lighten-2 */
}
.userbusinessunits {
    background: url('../assets/photo-1499750310107-5fef28a66643.png');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}
</style>